import { Routes } from '@angular/router';
import { DealerLayoutComponent } from './layouts/dealer-layout/dealer-layout.component';
import { NscLayoutComponent } from './layouts/nsc-layout/nsc-layout.component';
import { authTokenGuard } from './guards/authToken.guard';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AuthStartComponent } from './auth-start/auth-start.component';
import { AuthErrorComponent } from './auth-error/auth-error.component';

export const routes: Routes = [
  { path: '', component: AuthStartComponent, pathMatch: 'full' },
  { path: 'auth/callback', component: AuthCallbackComponent },
  { path: 'auth/error', component: AuthErrorComponent },
  {
    path: 'dealer',
    component: DealerLayoutComponent,
    canActivate: [authTokenGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard',     loadComponent: () => import('./dealer/dealer-dashboard/dealer-dashboard.component').then(m => m.DealerDashboardComponent) },
      { path: 'new-request/:id', loadComponent: () => import('./dealer/new-request/new-request.component').then(m => m.NewRequestComponent) },
      { path: 'new-request',   loadComponent: () => import('./dealer/new-request/new-request.component').then(m => m.NewRequestComponent) },
      { path: 'requests/:id',   loadComponent: () => import('./dealer/request-detail-dealer/request-detail-dealer.component').then(m => m.RequestDetailDealerComponent) },
      { path: 'mra-directory', loadComponent: () => import('./shared/mra-directory/mra-directory.component').then(m => m.MraDirectoryComponent) },
      { path: 'mra-details/:id', loadComponent: () => import('./shared/mra-details/mra-details.component').then(m => m.MraDetailsComponent) },
      { path: 'mra-details',   loadComponent: () => import('./shared/mra-details/mra-details.component').then(m => m.MraDetailsComponent) },
      { path: 'new-mra',       loadComponent: () => import('./shared/new-mra/new-mra.component').then(m => m.NewMraComponent) },
      { path: 'rules',         loadComponent: () => import('./shared/remrules/remrules.component').then(m => m.RemRulesComponent) },
    ]
  },
  {
    path: 'nsc',
    component: NscLayoutComponent,
    canActivate: [authTokenGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', loadComponent: () => import('./nsc/nsc-dashboard/nsc-dashboard.component').then(m => m.NscDashboardComponent) },
      { path: 'requests/:id/:remainingBudgetAmount', loadComponent: () => import('./nsc/request-detail-nsc/request-detail-nsc.component').then(m => m.RequestDetailNscComponent) },
      { path: 'mra-directory', loadComponent: () => import('./shared/mra-directory/mra-directory.component').then(m => m.MraDirectoryComponent) },
      { path: 'mra-details/:id', loadComponent: () => import('./shared/mra-details/mra-details.component').then(m => m.MraDetailsComponent) },
      { path: 'mra-details',   loadComponent: () => import('./shared/mra-details/mra-details.component').then(m => m.MraDetailsComponent) },
      { path: 'settings',  loadComponent: () => import('./nsc/settings/settings/settings.component').then(m => m.SettingsComponent) },
      { path: 'new-mra',   loadComponent: () => import('./shared/new-mra/new-mra.component').then(m => m.NewMraComponent) },
      { path: 'rules',     loadComponent: () => import('./shared/remrules/remrules.component').then(m => m.RemRulesComponent) },
    ]
  },
  { path: '**', redirectTo: '' }
];